import { Input } from "antd"
import { t } from "i18next"
import React, { useState } from "react"
import { InputSearchProps } from "../../../../lib/config/types"

const SearchInput: React.FC<InputSearchProps> = ({ handleSearchChange, defaultValue = "" }) => {
  const [value, setValue] = useState(defaultValue)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    handleSearchChange(e)
  }

  return (
    <div className="h-full flex flex-row gap-4 w-full lg:w-[360px]">
      <Input
        type="search"
        className="custom-input w-full"
        value={value}
        onChange={handleChange}
        placeholder={t("Search Media")}
      />
    </div>
  )
}

export default SearchInput
